import { redirect } from '@tanstack/react-router';
import {
  fetchPublicFeatureFlags,
  isDivorceProductEnabled,
} from '@/lib/public-feature-flags';

export async function requireDivorceProduct(): Promise<void> {
  const flags = await fetchPublicFeatureFlags();
  if (!isDivorceProductEnabled(flags)) {
    throw redirect({ to: '/', search: { hero: undefined } });
  }
}
